import type { MarketGoodsListFilter } from '../pages/MarketHome/states/GoodsListFilter.atom';

export const queryKey = {
  marketDetail: (marketId: number) => ['marketDetail', marketId],
  marketParent: (marketId: number) => ['marketParent', marketId],
  marketBanner: (marketId: number) => ['marketDetail', 'banner', marketId],
  marketCoupon: (marketId: number) => ['marketDetail', 'coupon', marketId],
  // 마켓홈(EXP1788)과 상품상세(EXP1789)는 노출 실험이 독립적이므로 캐시도 분리한다.
  // 키를 공유하면 한쪽이 채운 캐시를 다른 쪽이 enabled:false 여도 읽어 교차오염된다.
  mumulLiveProfileStatus: (profileSno: number) => [
    'market',
    'mumulLive',
    'profileStatus',
    profileSno,
  ],
  mumulLiveCurrentCampaign: (profileSno: number) => [
    'market',
    'mumulLive',
    'currentCampaign',
    profileSno,
  ],
  marketCategories: (marketId: number) => [
    'marketDetail',
    'categories',
    marketId,
  ],
  marketParentCategories: (marketId: number) => [
    'marketDetail',
    'parentCategories',
    marketId,
  ],
  marketGoodsCarousel: (marketId: number) => [
    'marketDetail',
    'carousel',
    marketId,
  ],
  marketParentGoodsCarousel: (marketId: number) => [
    'marketDetail',
    'parentCarousel',
    marketId,
  ],
  memberRequestsAvailability: (marketId: number) => [
    'marketDetail',
    'requestsAvailability',
    marketId,
  ],
  marketGoodsList: (marketId: number, params: MarketGoodsListFilter) => [
    'marketDetail',
    'goodsList',
    marketId,
    params,
  ],
  marketParentGoodsList: (marketId: number, params: MarketGoodsListFilter) => [
    'marketDetail',
    'parentGoodsList',
    marketId,
    params,
  ],
} as const;
